var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1 14.658a.796.796 0 0 1 .5-1.02.823.823 0 0 1 1.044.489c.968 2.688 3.639 4.426 6.55 4.262 2.91-.163 5.359-2.19 6.006-4.969.647-2.78-.664-5.642-3.216-7.021a6.666 6.666 0 0 0-7.809 1.089l-3.797 3.488a.831.831 0 0 1-1.156-.036.787.787 0 0 1 .036-1.13l3.779-3.471c2.579-2.518 6.55-3.064 9.739-1.34 3.19 1.724 4.828 5.302 4.02 8.776-.81 3.474-3.87 6.007-7.509 6.212-3.638.204-6.976-1.968-8.187-5.329zm-.464-5.065h4.091a.81.81 0 0 1 .819.8.81.81 0 0 1-.819.8H3.818a.81.81 0 0 1-.818-.8v-4.8c0-.442.366-.8.818-.8a.81.81 0 0 1 .818.8v4z",
    id: "0j4v0yb3ja"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#0j4v0yb3ja"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestore);
export default __webpack_public_path__ + "static/media/icon-restore.c810d87a.svg";
export { ForwardRef as ReactComponent };